import type React from 'react'
import SelfOnboardingModalWrapper from './SelfOnboardingModalWrapper'
import MainPopup from './Shared/MainPopup'

interface OnboardingModalShellProps {
  open: boolean
  onClose: () => void
  step: number
  setStep: (step: number) => void
  stepConfig: any[]
  primaryButtonProps: any
  secondaryButtonProps: any
  children?: React.ReactNode
  title?: string
}

const OnboardingModalShell: React.FC<OnboardingModalShellProps> = ({
  open,
  onClose,
  step,
  setStep,
  stepConfig,
  primaryButtonProps,
  secondaryButtonProps,
  children,
  title,
}) => {
  return (
    <SelfOnboardingModalWrapper
      className="w-full"
      showModal={open}
      onCloseModal={onClose}
      primaryButtonProps={primaryButtonProps}
      secondaryButtonProps={secondaryButtonProps}
      title={title}
      closeOnOutsideClick={false}
    >
      <MainPopup
        selectedMenu={step}
        stepCompleted={step}
        options={stepConfig.map(s => s.label)}
        onClose={onClose}
        onMenuSelect={setStep}
        title={stepConfig[step]?.label}
        description={stepConfig[step]?.description}
      >
        {children}
      </MainPopup>
    </SelfOnboardingModalWrapper>
  )
}

export default OnboardingModalShell
